export default (props, vars) => window.location.href;
